const c2fLiuYan = resolve => require(['@/view/whyd/c2fLiuYan'], resolve)
const ydCate1List = resolve => require(['@/view/whyd/ydCate1List'], resolve)
const ydCate2List = resolve => require(['@/view/whyd/ydCate2List'], resolve)
const ydZone = resolve => require(['@/view/whyd/ydZone'], resolve)
const ydDetail = resolve => require(['@/view/whyd/ydDetail'], resolve)
const cart = resolve => require(['@/view/whyd/cart'], resolve)
const orderCreate = resolve => require(['@/view/whyd/orderCreate'], resolve)
const evaluate = resolve => require(['@/view/whyd/evaluate'], resolve)
const factoryIndex = resolve => require(['@/view/whyd/factory/index'], resolve)
const routes = [
  {
    path: '/whyd/c2fLiuYan',
    name: '/whyd/c2fLiuYan',
    component: c2fLiuYan,
    meta: {
      // requireAuth: true
    }
  },{
    path: '/whyd/ydCate1List',
    name: '/whyd/ydCate1List',
    component: ydCate1List,
    meta: {
      // requireAuth: true
    }
  },{
    path: '/whyd/ydCate2List',
    name: '/whyd/ydCate2List',
    component: ydCate2List,
    meta: {
      // requireAuth: true
    }
  },{
    path: '/whyd/ydZone',
    name: '/whyd/ydZone',
    component: ydZone,
    meta: {
      // requireAuth: true
    }
  },{
    path: '/whyd/ydDetail',
    name: '/whyd/ydDetail',
    component: ydDetail,
    meta: {
      // requireAuth: true
    }
  },{
    path: '/whyd/cart',
    name: '/whyd/cart',
    component: cart,
    meta: {
      // requireAuth: true
    }
  },{
    path: '/whyd/orderCreate',
    name: '/whyd/orderCreate',
    component: orderCreate,
    meta: {
      // requireAuth: true
    }
  },{
    path: '/whyd/evaluate',
    name: '/whyd/evaluate',
    component: evaluate,
    meta: {
      // requireAuth: true
    }
  },{
    path: '/whyd/factory/index',
    name: '/whyd/factory/index',
    component: factoryIndex,
    meta: {
      // requireAuth: true
    }
  }]
export default {routes}



// WEBPACK FOOTER //
// ./src/router/whyd.js